import { useState } from "react";
import { Mail, MessageCircle, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

const testo = (nome, url, pin) => `Gentile ${nome || "cliente"},\nda oggi puoi vedere come lavora il tuo impianto fotovoltaico, quanto produce e quanto risparmi, e fare domande a Vesta, l'assistente di TORRI.\n\nApri questo link: ${url}\nPIN di accesso: ${pin}\n\nConserva il PIN e non condividerlo.`;

// Invio di link e PIN al cliente: email dal sistema (con copia a chi invia) o WhatsApp con testo già pronto
export function ClienteInvia({ u, params, token, url, pin, nome }) {
  const [msg, setMsg] = useState(() => testo(nome, url, pin));
  const [email, setEmail] = useState("");
  const [tel, setTel] = useState("");
  const [busy, setBusy] = useState(false);
  const mail = async () => {
    setBusy(true);
    try { await api.post(`${u}/${token}/email`, { to: email, subject: "Il tuo impianto fotovoltaico: accesso alla tua area", body: msg }, { params }); toast.success("Email inviata al cliente (in copia a te)"); }
    catch (e) { toast.error(e.response?.data?.detail || "Invio non riuscito"); }
    setBusy(false);
  };
  const wa = () => {
    const n = tel.replace(/\D/g, "");
    const num = n ? (n.length <= 10 ? `39${n}` : n) : "";
    window.open(`https://wa.me/${num}?text=${encodeURIComponent(msg)}`, "_blank", "noopener");
  };
  const inp = "h-9 min-w-0 flex-1 rounded-lg border border-emerald-200 bg-white px-2.5 text-xs outline-none focus:border-emerald-400";
  return (
    <div className="space-y-2 border-t border-emerald-200 pt-2" data-testid="cliente-invia">
      <textarea value={msg} onChange={(e) => setMsg(e.target.value)} rows={6} data-testid="cliente-invia-testo"
        className="w-full rounded-lg border border-emerald-200 bg-white p-2 text-xs outline-none focus:border-emerald-400" />
      <div className="flex gap-2">
        <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" placeholder="Email del cliente" className={inp} data-testid="cliente-invia-email" />
        <button type="button" onClick={mail} disabled={busy || !email.includes("@")} data-testid="cliente-invia-email-btn"
          className="inline-flex shrink-0 items-center gap-1.5 rounded-lg bg-sky-500 px-3 text-xs font-bold text-white disabled:opacity-40">
          {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Mail className="h-3.5 w-3.5" />}Invia email</button>
      </div>
      <div className="flex gap-2">
        <input value={tel} onChange={(e) => setTel(e.target.value)} inputMode="tel" placeholder="Cellulare del cliente (facoltativo)" className={inp} data-testid="cliente-invia-tel" />
        <button type="button" onClick={wa} data-testid="cliente-invia-wa-btn"
          className="inline-flex shrink-0 items-center gap-1.5 rounded-lg bg-[#25D366] px-3 text-xs font-bold text-white"><MessageCircle className="h-3.5 w-3.5" />WhatsApp</button>
      </div>
    </div>
  );
}
